const ApiURL = {
  _uploadImage: "v1/studio/upload-image",

  _login: "v1/coach/login",
  _signUp: "v1/coach/sign-up",
  _linkGym: "v1/coach/link-gym",
  _gymInfo: "v1/coach/gym-info",
  _gymAddEdit: "v1/gym/add-edit",
  _joinActivity: "v1/activity/coach-join-activity",
  _syncActivity: "v1/activity/sync",
  _startWorkout: "v1/activity/start",
  _getSpecialisations: "v1/activity/list-specialisations",
  _endWorkout: "v1/activity/end",
  _getSignUpData: "v1/coach/access-token-login",
  _updateProfile: "v1/coach/update-profile",
  _changePassword: "v1/coach/verify-old-reset-new-password",

  _dashboard: "v1/admin/dashboard",
  _dashboardEport: "v1/admin/dashboard-export",

  _getUsers: "api/v1/fitclub/users",
  _addActivity: "api/v1/fitclub/add-activity",
  _getActivityTypes: "api/v1/fitclub/get-activity-types",

  _getScheduledActivity: "v1/coach/list-activities",
  _getBookedMemberList: "v1/studio/fetch-activity-booked-user-list",
  _cancelScheduledActivity: "v1/activity/cancel-scheduled-activities",
  _scheduledActivity: "v1/activity/create-scheduled-activity",
  _scheduledActivityV2: "v2/activity/create-scheduled-activity",
  _editScheduledActivity: "v2/activity/edit-scheduled-activity",
  _coachGenerateLink: "v1/activity/coach-generate-link",
  _openWaitingRoom: "v1/activity/open-waiting-room",
  _activeRoomDetail: "v1/activity/coach/get-details",
  _getActivityData: "v1/activity/coach/get-details",
  _getActivityDataThirdparty: "v1/studio/get-activity-details",
  _removeUser: "v1/activity/coach/remove-user",

  _createActivity: "v1/admin/create-activity",
  _createActivityV2: "v2/admin/create-activity",
  _editActivity: "v1/admin/edit-activity",
  _editActivityV2: "v2/admin/edit-activity",
  _getActivity: "v1/admin/list-activities",
  _getCoach: "v1/admin/list-coaches",
  _assignCoach: "v1/activity/assign-coach",
  _getS3SignedUrl: "v1/coach/get-s3-signed-url-for-upload",
  _getS3SignedUrlProgress:
    "v1/activity/update-ondemand-video-conversion-status",
  _updateActivityStatus: "v1/admin/update-activity-status",

  _activityList: "v1/coach/list-activities",
  _getActivitySummary: "v1/coach/activity-summary",
  _getCoachMember: "v1/studio/gym-link-requests",
  _approveRejectCoachMember: "v1/gym/update-link-status",
  _memberWoHistory: "v1/coach/member-workout-history",
  _startLiveStreaming: "v2/activity/coach/start-live-streaming",
  _stopLiveStreaming: "v2/activity/coach/stop-live-streaming",
  _getRooms: "v1/rooms/list",
  _removeRoom: "v1/rooms/remove",
  _createRoom: "v1/gym/create-room",
  _forgotPassword: "v1/coach/forgot-password",
  _resetCoachPassword: "v1/coach/reset-password",
  _resetMemberPassword: "v1/member/reset-password",
  _gymAndStudio: "v1/gym/list",
  _activityLogos: "/v1/activity/get-logos",
  _leaveWaitingRoom: "/v1/activity/coach/leave-from-waiting-room",
  _uploadFile: "v1/coach/upload-file-get-url",
  _uploadClassFile: "v1/studio/upload-file-get-url",
  _mindBodyConfig: "/v1/coach/configure-addon",
  _integrationList: "/v1/coach/list-activated-addon",
  _getMtClassType: "v1/coach/fetch-mt-class-types",
  _regenerateCode: "/v1/coach/mb-regenerate-activation-code",
  _updateMindBodyStatus: "/v1/coach/activate-deactivate-addon",
  _refrshMindBodyStatus: "/v1/coach/refresh-mindbody-classes",
  _tellUsMore: "/v1/coach/integration-suggestions",

  _getMember: "v1/admin/list-members",
  _addBulkMember: "/v1/gym/invite-bulk-users",
  _getBulkMember: "/v1/gym/list-invited-users",
  _attemptStats: "/v1/coach/attempt-stats",
  _deviceActivated: "v1/coach/tv-login-with-code",
  _addPayment: "v1/payment/add-payment-method",
  _listPaymentMethods: "v1/payment/list-payment-methods",
  _listInvoices: "v1/payment/list-invoices",
  _listPricings: "v1/payment/list-pricings",
  _createSubscription: "v1/payment/create-subscription",
  _removeCard: "v1/payment/remove-payment-method",
  _setDefaultPayment: "v1/payment/set-default-payment-method",
  _getLocation: "v1/locations/list",
  _removeLocation: "v1/locations/remove",
  _createLocation: "v1/locations/add-edit",
  _changeLocationStatus: "v1/locations/update-config",
  _changeLocationSingleStatus: "v1/locations/update-status",

  _getTemplate: "v1/workout/builder/list-class-templates",
  _getTemplateDetail: "v1/workout/builder/get-class-template-details",
  _updateTemplate: "v1/workout/builder/update-class-template-status",
  // _addEditTemplate: "v1/workout/builder/add-edit-template",
  _addEditTemplate: "v2/workout/builder/add-edit-template",

  _appDetail: "v1/member/app-versions",
  _linkNewStaff: "v1/gym/add-staff",
  // _linkNewOwner: "v1/gym/add-new-owner",
  // _linkNewCoach: "v1/gym/add-new-coach",
  _hardDeleteOwner: "v1/gym/hard-delete-owner",
  _setPassword: "/v1/coach/verify-old-reset-new-password",
  _upgradePlan: "/v1/payment/resubscribe-or-upgrade-subscription",
  _fetchCouponDetails: "/v1/payment/fetch-coupon-details",
  _cancelSubscription: "/v1/payment/cancel-subscription",
  _contactSupport: "/v1/payment/contact-support",
  _listPendingInvoices: "/v1/payment/list-pending-invoices",
  _clearPendingInvoices: "/v1/payment/clear-pending-invoices",
  _proratedCharges: "/v1/payment/calculate-prorated-charges",
  _getSessionToken: "/v1/activity/refresh-openvidu-token",
  _staffJoinVideo: "/v1/activity/staff-join-video",
  _generateZoomToken: "/v1/zoom/generate-user-token",
  _openHangoutRoom: "v1/activity/start-hangout",
  _endHangoutRoom: "v1/activity/end-hangout",

  _deleteUser: "v1/user/authorize-deletion",

  _uploadMedia: "v1/studio/upload-media",
  _addMedia: "v1/studio/add-media",
  _updateMedia: "v1/studio/update-media",
  _getMedia: "v1/studio/list-media",
  _deleteMedia: "v1/studio/delete-media",

  _classByCategoryData: "v1/studio/list-activity-of-particular-category",
  _categoryData: "v1/studio/list-categories",
  _addCategory: "v1/studio/add-category",
  _editCategory: "v1/studio/edit-category",
  _updateCategoryStatus: "v1/studio/update-category-status",
  _dragDropCategory: "v1/studio/drag-and-drop-category",
  _deleteCategory: "v1/studio/delete-category",
  _getCategoryIcon: "v1/studio/list-category-icons",

  _getSegmentIcon: "v1/studio/list-segment-icons",
  _getCollaborator: "v1/studio/list-media-collaborator",

  _announcementData: "v1/studio/announcements",
  _addAnnouncement: "v1/studio/add-edit-announcement",
  _announcementDetail: "v1/studio/announcements-detail",
  _uploadMediaAnnouncement: "v1/studio/upload-image",
  _deleteAnnouncement: "v1/studio/announcement",
  _dragDropAnnouncement: "v1/studio/drag-and-drop-announcement",
  _getS3SignedUrlAnnouncement: "v1/studio/s3-upload-details",

  _getTransactionsList: "v1/member-payment/transactions",
  _refundTransactions: "v1/member-payment/issue-refund",
  _getSubscriptionsList: "v1/member-payment/subscriptions",
  _pauseSubscriptions: "v1/member-payment/pause-subscription",
  _resumeSubscriptions: "v1/member-payment/resume-subscription",

  _getCouponList: "v1/member-payment/promotion_codes",
  _addCoupon: "v1/member-payment/create-promotion_code",
  _deleteCoupon: "v1/member-payment/member/delete-payment-method",
  _updateCoupon: "v1/member-payment/update-promo-code-status",

  _getPlanList: "v1/member-payment/plans",
  _updatePlanStatus: "v1/member-payment/update-plan-status",
  _duplicatePlan: "v1/member-payment/duplicate-plan",
  _uploadPlanFile: "v1/member-payment/upload-plan-image-get-url",
  _addPlan: "v1/member-payment/create-plan",
  _updatePlan: "v1/member-payment/update-plan",
  _planDetail: "v1/member-payment/plan-detail",

  _stripeOnboarding: "v1/member-payment/connect-onboarding",
  _updatePaymentSettingStatus:
    "v1/member-payment/update-payment-setting-status",
};
export default ApiURL;
